"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = require("./config");
var _styledColourSwatch = require("./styled-colour-swatch");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var useMemo = _react["default"].useMemo,
  useCallback = _react["default"].useCallback;
var propTypes = {
  swatches: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    imageSrc: _propTypes["default"].string
  }))
};
var defaultProps = {
  swatches: []
};
function ColourSwatch(_ref) {
  var swatches = _ref.swatches;
  var swatchSize = useMemo(function () {
    return {
      xxs: 'small',
      m: 'medium',
      l: 'large'
    };
  }, []);
  var countSize = useMemo(function () {
    return {
      xxs: 'm2',
      m: 'm1',
      l: '1'
    };
  }, []);
  var StyledCountComponents = {
    xxs: _styledColourSwatch.StyledCountExtraExtraSmall,
    xs: _styledColourSwatch.StyledCountExtraSmall,
    m: _styledColourSwatch.StyledCountMedium,
    l: _styledColourSwatch.StyledCountLarge,
    1350: _styledColourSwatch.StyledCountExtraLarge
  };
  var renderColoursText = useCallback(function (device) {
    return "+".concat(swatches.length - _config.visibleSwatchesCount[device].min, " colours");
  }, [swatches]);
  var getOneOrMany = useCallback(function (swatchesCount) {
    return swatchesCount > 1 ? 'colours' : 'colour';
  });
  var getExtraSwatchesText = useCallback(function (device) {
    var hiddenCount = swatches.length - _config.visibleSwatchesCount[device].min;
    var colours = swatches.map(function (swatch, index) {
      return index < _config.visibleSwatchesCount[device].min ? swatch === null || swatch === void 0 ? void 0 : swatch.displayName : null;
    }).filter(Boolean);
    return "Available in ".concat(colours.join(', '), " and ").concat(hiddenCount, " more colours");
  }, [swatches]);
  var getSrOnlyText = useCallback(function (device) {
    var hasExtraCount = swatches.length > _config.visibleSwatchesCount[device].max;
    if (!hasExtraCount) {
      var colours = swatches.map(function (swatch) {
        return swatch === null || swatch === void 0 ? void 0 : swatch.displayName;
      });
      return "Available in ".concat(colours.join(', '), " ").concat(getOneOrMany(colours.length));
    }
    return getExtraSwatchesText(device);
  }, [swatches]);
  var swatchesTotalCount = swatches.length;
  if (swatchesTotalCount === 0) return null;
  return /*#__PURE__*/_react["default"].createElement(_styledColourSwatch.ColourContainer, null, (swatches === null || swatches === void 0 ? void 0 : swatches.length) && swatches.slice(0, _config.visibleSwatchesCount['1350'].max).map(function (swatch, index) {
    var sizeParam = (swatch === null || swatch === void 0 ? void 0 : swatch.imageSrc) && '?$20x20_standard$';
    return /*#__PURE__*/_react["default"].createElement(_styledColourSwatch.StyledSwatch, {
      key: swatch === null || swatch === void 0 ? void 0 : swatch.displayName,
      swatchNumber: index + 1,
      swatchesTotalCount: swatchesTotalCount,
      size: swatchSize,
      name: swatch === null || swatch === void 0 ? void 0 : swatch.displayName,
      imageSrc: sizeParam ? swatch.imageSrc + sizeParam : swatch === null || swatch === void 0 ? void 0 : swatch.imageSrc
    });
  }), /*#__PURE__*/_react["default"].createElement(_styledColourSwatch.StyledCount, {
    swatchesTotalCount: swatchesTotalCount,
    type: "paragraph",
    size: countSize,
    "aria-hidden": true
  }, Object.entries(StyledCountComponents).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      size = _ref3[0],
      StyledComponent = _ref3[1];
    return /*#__PURE__*/_react["default"].createElement(StyledComponent, {
      key: size
    }, renderColoursText(size));
  })), Object.entries(StyledCountComponents).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      size = _ref5[0],
      StyledComponent = _ref5[1];
    return /*#__PURE__*/_react["default"].createElement(StyledComponent, {
      key: size
    }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, getSrOnlyText(size)));
  }));
}
ColourSwatch.propTypes = propTypes;
ColourSwatch.defaultProps = defaultProps;
var _default = exports["default"] = ColourSwatch;